import React from 'react';
import { initialState } from './helpers';
import { Paper, Stack } from '@mui/material';
import useDebugInformation from '../../../../../../../../hooks/useDebugInformation';
import "./style.css"
import CalendarPickerElement from './CalendarPickerElement';
import CalendarSelectorElement from './CalendarSelectorElement';
import createFastContext from './../../../../../../../Shared/ContextProvider/index';
import EmergencyPopUp from './EmergencyPopUp';

const name = "DateSelector";

const today = new Date()
const tomorrow = new Date(today)
tomorrow.setDate(tomorrow.getDate() + 1);
const future = new Date()
future.setDate(future.getDate() + 365 * 2)

type DateSelectorProps = {
    parent: string
}

export const { Provider, useStore } = createFastContext(initialState());

const DateSelector: React.FC<DateSelectorProps> = ({ parent }) => {
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { debugName })



    return (
        <Provider>
            <Paper elevation={2} sx={{ p: 1 }}>
                <Stack spacing={2} direction="row" justifyContent="space-between">
                    <CalendarSelectorElement parent={debugName} />
                    <CalendarPickerElement />
                </Stack>
            </Paper >
            <EmergencyPopUp />
        </Provider >
    );
}

DateSelector.displayName = name;


export default React.memo(DateSelector)

